import { Sidebar } from "./Sidebar";
import { ReactNode } from "react";

export function Shell({ children }: { children: ReactNode }) {
  return (
    <div className="min-h-screen bg-slate-50 dark:bg-slate-950 flex flex-col lg:flex-row">
      <Sidebar />
      <main className="flex-1 lg:pl-72 transition-all duration-300">
        <div className="max-w-7xl mx-auto p-4 sm:p-6 lg:p-8 animate-enter">
          {children}
        </div>
      </main>
    </div>
  );
}
